<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<header class="slds-page-header">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title">
      <div class="slds-media">
        <div class="slds-media__figure">
          <span class="slds-icon_container" title="Resources Overview">
            <img [alt]="title"
                 height="38px" src="/assets/accorto/resource-100.svg" width="38px">
          </span>
        </div>
        <div class="slds-media__body">
          <div class="slds-page-header__name">
            <div class="slds-page-header__name-title">
              <h1>
                <span class="slds-page-header__title slds-truncate" title="Calendar">Resources Overview</span>
              </h1>
            </div>
          </div>
          <p class="slds-page-header__name-meta">Entered Effort</p>
        </div>
      </div>
    </div>
    <div class="slds-page-header__col-actions">
      <div class="slds-page-header__controls">
        <div class="slds-page-header__control">
          <div class="slds-avatar slds-m-right_small">
            <img *ngIf="busy" alt="Loading ..." id="busy" src="/assets/images/busy.svg" title="Loading ...">
          </div>
          <button (click)="onRefresh()"
                  class="slds-button slds-button_icon slds-button_icon-border"
                  i18n-title id="r-refresh" title="Refresh">
            <svg aria-hidden="true" class="slds-button__icon">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#refresh"></use>
            </svg>
            <span class="slds-assistive-text" i18n>Refresh</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="slds-page-header__row slds-page-header__row_gutters">
    <div class="slds-page-header__col-details">
      <ul class="slds-page-header__detail-row">
        <li class="slds-page-header__detail-block">
          <fieldset class="slds-form-element">
            <legend class="slds-form-element__legend slds-form-element__label" i18n>Group by</legend>
            <div class="slds-form-element__control" style="display: flex">
              <!--span class="slds-radio" style="display: inline-block">
                <input (click)="onDayWeekMonthClick($event)" checked=""
                       id="radio-day" name="options" type="radio"
                       value="day"/>
                <label class="slds-radio__label" for="radio-day">
                  <span class="slds-radio_faux"></span>
                  <span class="slds-form-element__label">Day</span>
                </label>
              </span-->
              <span class="slds-radio">
                <input (click)="onDayWeekMonthClick($event)"
                       id="r-radio-week" name="options" type="radio"
                       value="week"/>
                <label class="slds-radio__label" for="r-radio-week">
                  <span class="slds-radio_faux"></span>
                  <span class="slds-form-element__label">Week</span>
                </label>
              </span>
              <span class="slds-radio">
                <input (click)="onDayWeekMonthClick($event)" checked=""
                       id="r-radio-month" name="options" type="radio"
                       value="month"/>
                <label class="slds-radio__label" for="r-radio-month">
                  <span class="slds-radio_faux"></span>
                  <span class="slds-form-element__label">Month</span>
                </label>
              </span>
            </div>
          </fieldset>
        </li>
        <li class="slds-page-header__detail-block">
          <acc-date-element (dateSelected)="onDateFromSelected($event)"
                            class="slds-form-element_stacked"
                            label="Date From"
                            theId="dateFrom"></acc-date-element>
        </li>
        <li class="slds-page-header__detail-block">
          <acc-date-element (dateSelected)="onDateToSelected($event)"
                            class="slds-form-element_stacked"
                            label="Date To"
                            theId="dateTo"></acc-date-element>
        </li>
      </ul>
    </div>
  </div>
</header>


<div class="slds-m-vertical_medium" id="resources">
  <h3 class="slds-text-heading_small" i18n>Entered Hours</h3>
  <div class="slds-scrollable_x">
    <psa-time-line-stacked [dayWeekMonth]="dayWeekMonth"
                           [definition]="hoursDefinition"
                           [sources]="timeSources"
                           id="res-t">
    </psa-time-line-stacked>
  </div>

  <h3 class="slds-text-heading_small slds-m-top_small" i18n>By Projects</h3>
  <div class="slds-scrollable_x">
    <psa-time-line-stacked [dayWeekMonth]="dayWeekMonth"
                           [definition]="projectsDefinition"
                           [sources]="timeSources"
                           id="res-p">
    </psa-time-line-stacked>
  </div>
</div>


<button (click)="onSelectResource()"
        class="slds-button slds-button_brand slds-m-vertical_small"
        i18n id="r-select-resource">Select a Resource
</button>
<acc-modal-float (closing)="onResourceSelected($event === true ? undefined : null)"
                 *ngIf="showResourceSelect"
                 title="Select Resource">
  <acc-data-record-selector (recordSelected)="onResourceSelected($event)"
                            [columnNames]="resourceSelectColumns"
                            [records]="resourceRecords"></acc-data-record-selector>
</acc-modal-float>


<div *ngIf="resource" id="resorce">
  <h2 class="slds-text-heading_small slds-m-top_medium" id="resource">{{resource.name}}</h2>

  <h3 class="slds-text-heading_small" i18n>Entered Hours</h3>
  <div class="slds-scrollable_x">
    <psa-time-line-stacked [dayWeekMonth]="dayWeekMonth"
                           [definition]="hoursDefinition"
                           [sources]="timeSourcesResource"
                           id="res1-t">
    </psa-time-line-stacked>
  </div>
  <h3 class="slds-text-heading_small slds-m-top_small" i18n>By Projects</h3>
  <div class="slds-scrollable_x">
    <psa-time-line-stacked [dayWeekMonth]="dayWeekMonth"
                           [definition]="projectsDefinition"
                           [sources]="timeSourcesResource"
                           id="res1-p">
    </psa-time-line-stacked>
  </div>
</div>




